export default "__VITE_ASSET__q6o9fMad__"